export function average(arr) {
    return arr.reduce((sum, n) => (isNaN(n) ? sum : sum + n), 0) / arr.length;
}

export function swapDict(dict) {
    let newDict = {};

    for (const [key, value] of Object.entries(dict)) {
        newDict[value] = key;
    }

    return newDict;
}

export function getKeyByValue(object, value) {
    return Object.keys(object).find((key) => object[key] === value);
}

export function shallowEqual(obj1, obj2, keys = null) {
    const compareKeys = keys ?? Object.keys(obj1);
    return compareKeys.every(key => obj1[key] === obj2[key]);
}

export function simpleObjectCompare(o1, o2) {
    for (let p in o1) {
        if (Object.prototype.hasOwnProperty.call(o1, p)) {
            if (o1[p] !== o2[p]) {
                return false;
            }
        }
    }
    for (let p in o2) {
        if (Object.prototype.hasOwnProperty.call(o2, p)) {
            if (o1[p] !== o2[p]) {
                return false;
            }
        }
    }
    return true;
}

export const objectDeepClone = (obj) => JSON.parse(JSON.stringify(obj));

export function deepObjectCompare(a, b) {
    if (a === b) return true;

    if (
        typeof a !== 'object' ||
    a === null ||
    typeof b !== 'object' ||
    b === null
    )
        return false;

    const keysA = Object.keys(a);
    const keysB = Object.keys(b);

    if (keysA.length !== keysB.length) return false;

    for (let key of keysA) {
        if (!keysB.includes(key) || !deepObjectCompare(a[key], b[key]))
            return false;
    }

    return true;
}

// returns object with differnces based on values in copy
export function getObjectDifferences(original, copy) {
    if (
        typeof original !== 'object' ||
    original === null ||
    typeof copy !== 'object' ||
    copy === null
    ) {
        return original === copy ? undefined : copy;
    }

    if (Array.isArray(copy)) {
        return JSON.stringify(original) === JSON.stringify(copy) ? undefined : copy;
    }

    const diff = {};
    for (const key in copy) {
        const difference = getObjectDifferences(original[key], copy[key]);
        if (difference !== undefined) {
            diff[key] = difference;
        }
    }

    return Object.keys(diff).length ? diff : undefined;
}

export function debounce(func, wait) {
    let timeoutId;
    const debounced = function (...args) {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
            func.apply(this, args);
        }, wait);
    };
    debounced.cancel = function () {
        clearTimeout(timeoutId);
    };
    return debounced;
}
